import ComponentModule from "@eisinc/Overrides/Components/ShipToSelector";

export * from "@eisinc/Overrides/Components/ShipToSelector";

export default ComponentModule;
